export function quoteSmsHref(userAgent = typeof navigator === 'undefined' ? '' : navigator.userAgent) {
  const separator = /iPad|iPhone|iPod/.test(userAgent) ? '&' : '?';
  return `sms:+17724945048${separator}body=${encodeURIComponent("Hi, I'd like a junk removal quote. Here's a photo:")}`;
}
